/**
 * cart-shipping-calc.js v6 — FINAL
 * Ponte entre minicart/cartpage e a API do Kokfy.
 *
 * Estratégia:
 * Chama a API do Kokfy DIRETAMENTE, sem depender do widget.
 * Endpoint: POST https://calculo-frete-produto.kokfy.com/api/carrier/shopify?shop={shop}
 * Body: { items: [{variant_id, price, quantity, sku}], cep, shop, origin }
 *
 * Fluxo:
 *   1. Usuário digita CEP e clica em "Consultar"
 *   2. Busca /cart.js para dados dos itens (variant_id, price, quantity, sku)
 *   3. Busca ViaCEP para localização
 *   4. Chama API do Kokfy diretamente
 *   5. Renderiza os resultados no container
 */
(function () {
  'use strict';
  var KOKFY_API = 'https://calculo-frete-produto.kokfy.com/api/carrier/shopify';
  var KOKFY_STATS = 'https://calculo-frete-produto.kokfy.com/api/statistics/event';

  /* ===== CSS dos resultados ===== */
  function resultCSS(id) {
    return '<style>'
      + '#' + id + ' .loc-bar{display:flex;align-items:center;gap:8px;background:#fafafa;padding:10px;border-radius:4px;margin-bottom:15px;font-size:12px;color:#555;}'
      + '#' + id + ' .loc-bar svg{width:16px;height:16px;flex-shrink:0;}'
      + '#' + id + ' ul{list-style:none!important;padding:0!important;margin:0!important;display:flex!important;flex-direction:column!important;gap:0!important;}'
      + '#' + id + ' li{display:flex!important;justify-content:space-between!important;align-items:center!important;padding:12px 2px!important;border-bottom:1px solid #f0f0f0!important;margin:0!important;}'
      + '#' + id + ' li:last-child{border-bottom:none!important;}'
      + '#' + id + ' .ship-name{display:flex!important;flex-direction:column!important;gap:4px!important;text-align:left!important;}'
      + '#' + id + ' .ship-name span:first-child{font-weight:600!important;font-size:13px!important;color:#111!important;line-height:1.2!important;}'
      + '#' + id + ' .ship-name span:last-child{font-size:12px!important;color:#777!important;line-height:1.2!important;}'
      + '#' + id + ' .ship-price{font-weight:700!important;font-size:14px!important;color:#51a559!important;white-space:nowrap!important;text-align:right!important;}'
      + '</style>';
  }

  function setMsg(el, t, c) {
    el.innerHTML = '<p style="color:' + (c || '#c0392b') + ';font-size:13px;margin:0;">' + t + '</p>';
  }

  function resetBtn(b, s) {
    b.disabled = false;
    s.textContent = 'Consultar';
  }

  function getShop() {
    if (window.Shopify && window.Shopify.shop) return window.Shopify.shop;
    return window.location.hostname;
  }

  /* ==========================================================
   * CONSULTA PRINCIPAL — API Kokfy direta
   * ========================================================== */
  function isProductPage() {
    return !!(window.meta && window.meta.page && window.meta.page.pageType === 'product');
  }

  async function calcularFrete(cep, carrierId, carrierEl, btn, span, useCartOnly) {
    var shop = getShop();
    var origin = window.location.hostname;

    try {
      var items;

      // Página de produto SEM forçar carrinho → usa meta.product (variant selecionada)
      // Isso só se aplica a calculadores fora do minicart/cart page (ex: na própria product page)
      if (!useCartOnly && isProductPage() && window.meta && window.meta.product) {
        var product = window.meta.product;
        var urlParams = new URLSearchParams(window.location.search);
        var variantId = urlParams.get('variant');
        if (!variantId && window.ShopifyAnalytics && window.ShopifyAnalytics.meta) {
          variantId = window.ShopifyAnalytics.meta.selectedVariantId;
        }
        if (!variantId && product.variants && product.variants.length > 0) {
          variantId = product.variants[0].id;
        }
        var variant = null;
        if (product.variants) {
          variant = product.variants.find(function(v) { return String(v.id) === String(variantId); })
                 || product.variants[0];
        }
        var qtyInput = document.querySelector("input[name='quantity']");
        items = { items: [{
          variant_id: variantId,
          price: variant ? variant.price : 0,
          quantity: qtyInput ? parseInt(qtyInput.value) || 1 : 1,
          sku: variant ? (variant.sku || null) : null
        }]};
        console.log('[Kokfy API] Página de produto. Variant:', variantId);

      } else {
        // Minicart / cart page / forçado → usa /cart.js (itens reais do carrinho)
        // Retry once on failure (503 can happen briefly after cart mutations)
        var cartResp = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!cartResp.ok) {
          await new Promise(function(r) { setTimeout(r, 1000); });
          cartResp = await fetch('/cart.js', { credentials: 'same-origin' });
        }
        if (!cartResp.ok) {
          setMsg(carrierEl, 'Erro ao consultar o carrinho. Tente novamente.');
          resetBtn(btn, span);
          return;
        }
        var cart = await cartResp.json();

        if (!cart.items || cart.items.length === 0) {
          setMsg(carrierEl, 'Adicione produtos ao carrinho para calcular o frete.');
          resetBtn(btn, span);
          return;
        }

        items = {
          items: cart.items.map(function (item) {
            return {
              variant_id: item.variant_id,
              price: item.price,
              quantity: item.quantity,
              sku: item.sku || null
            };
          })
        };
      }

      // 3. Buscar localização via ViaCEP
      var locHTML = '';
      try {
        var viacepResp = await fetch('https://viacep.com.br/ws/' + cep + '/json/');
        var addr = await viacepResp.json();
        if (!addr.erro) {
          var locText =
            (addr.logradouro ? addr.logradouro + ', ' : '') +
            (addr.bairro ? addr.bairro + ' - ' : '') +
            addr.localidade + ' - ' + addr.uf;

          locHTML = '<div class="loc-bar">'
            + '<svg viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>'
            + '<span>' + locText + '</span>'
            + '</div>';

          // Envia estatística ao Kokfy (fire-and-forget)
          fetch(KOKFY_STATS + '?shop=' + shop, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              name: 'request',
              type: 'zipcode',
              count: '1',
              state: addr.uf,
              city: addr.localidade,
              zip: cep,
              country: 'BR'
            })
          }).catch(function () {});
        }
      } catch (e) {
        console.warn('[Kokfy API] ViaCEP falhou:', e);
      }

      // 4. Chamar a API do Kokfy
      console.log('[Kokfy API] Chamando API com', items.items.length, 'itens, CEP:', cep);

      var resp = await fetch(KOKFY_API + '?shop=' + shop, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: items.items,
          cep: cep,
          shop: shop,
          origin: origin
        })
      });

      var data = await resp.json();
      console.log('[Kokfy API] Resposta:', data);

      // 5. Renderizar resultados
      var html = '';
      if (data && data.length > 0) {
        html += '<ul>';
        data.forEach(function (e) {
          html += '<li style="border-color: #fafafa">'
            + '<div class="ship-name">'
            + '<span>' + e.name + '</span>'
            + '<span>' + (e.shipping_date || '') + '</span>'
            + '</div>'
            + '<span class="ship-price">' + e.price + '</span>'
            + '</li>';
        });
        html += '</ul>';
      } else {
        html = '<div style="text-align:center;font-size:14px;padding:1rem;">Chame nossa equipe no WhatsApp para cotar</div>';
      }

      carrierEl.innerHTML = resultCSS(carrierId) + locHTML + html;
      resetBtn(btn, span);

    } catch (err) {
      console.error('[Kokfy API] Erro:', err);
      setMsg(carrierEl, 'Erro ao consultar o frete. Tente novamente.');
      resetBtn(btn, span);
    }
  }

  /* ===== CONFIGURAÇÃO DOS BOTÕES ===== */
  var BRIDGES = [
    { btnId: 'minicart-cep-btn', inputId: 'minicart-cep', carrierId: 'minicart-calc-carrier', useCartOnly: true },
    { btnId: 'cartpage-cep-btn', inputId: 'cartpage-cep', carrierId: 'cartpage-calc-carrier', useCartOnly: true }
  ];

  console.log('[KokfyCalc] cart-shipping-calc.js v7 loaded');

  /* ── DIAGNÓSTICO GLOBAL: loga TODOS os cliques para identificar onde o clique vai ──
     Remover após identificar o problema. */
  document.addEventListener('click', function (diagEvt) {
    var t = diagEvt.target;
    var tag = t.tagName;
    var id  = t.id || '(sem id)';
    var cls = t.className || '(sem classe)';
    var pe  = window.getComputedStyle(t).pointerEvents;

    // Sempre loga qualquer clique
    console.log('[KokfyCalc-DIAG] CLIQUE → tag:', tag, '| id:', id, '| class:', cls, '| pointer-events:', pe);

    // Se o clique foi "perto" do minicart, loga estado do painel
    var panel = document.getElementById('shipping-cep');
    if (panel) {
      var panelPE   = window.getComputedStyle(panel).pointerEvents;
      var panelOpen = panel.classList.contains('is-open');
      console.log('[KokfyCalc-DIAG] #shipping-cep → is-open:', panelOpen, '| pointer-events:', panelPE);
    } else {
      console.log('[KokfyCalc-DIAG] #shipping-cep NÃO ENCONTRADO no DOM');
    }

    // Loga ancestors do target até encontrar minicart
    var ancestor = t.parentElement;
    var path = [];
    while (ancestor && path.length < 6) {
      path.push((ancestor.tagName || '') + (ancestor.id ? '#' + ancestor.id : '') + (ancestor.className ? '.' + String(ancestor.className).split(' ').join('.') : ''));
      ancestor = ancestor.parentElement;
    }
    console.log('[KokfyCalc-DIAG] ancestrais:', path.join(' > '));
  }, true /* capture — dispara SEMPRE antes de qualquer handler */);

  /* Event delegation: único listener no document, funciona mesmo após
     substituição total do innerHTML do minicart pelo brinde/AJAX */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest
      ? e.target.closest('#minicart-cep-btn, #cartpage-cep-btn')
      : (e.target.id === 'minicart-cep-btn' || e.target.id === 'cartpage-cep-btn' ? e.target : null);

    if (!btn || btn.disabled) return;

    var bridge = null;
    for (var i = 0; i < BRIDGES.length; i++) {
      if (btn.id === BRIDGES[i].btnId) { bridge = BRIDGES[i]; break; }
    }
    if (!bridge) return;

    var input     = document.getElementById(bridge.inputId);
    var carrierEl = document.getElementById(bridge.carrierId);
    if (!input || !carrierEl) return;

    var cep = input.value.replace(/\D/g, '');
    if (cep.length !== 8) {
      setMsg(carrierEl, 'Digite um CEP válido com 8 dígitos.');
      return;
    }

    var sp = btn.querySelector('span') || btn;
    btn.disabled = true;
    sp.textContent = 'Consultando...';
    setMsg(carrierEl, 'Aguarde, calculando...', '#666');

    calcularFrete(cep, bridge.carrierId, carrierEl, btn, sp, bridge.useCartOnly);
  });

  function clearKokfyLocalStorage() {
    // Apaga apenas chaves do localStorage relacionadas ao Kokfy/CEP
    for (var i = 0; i < localStorage.length; i++) {
      var key = localStorage.key(i);
      if (key && (key.toLowerCase().includes('kokfy') || key.toLowerCase().includes('zip'))) {
        try { localStorage.removeItem(key); } catch (e) {}
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearKokfyLocalStorage);
  } else {
    clearKokfyLocalStorage();
  }

  // MutationObserver removido — event delegation não precisa de re-bind após mudanças no DOM
})();
